import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import {
  accountTableColumns,
  accountTableInit,
  statusIcon,
} from '../../constants';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { AppUtils } from '../../utlis/app-utils';
import { OneBreadcrumb } from '@one/angular-kit/navigation';
import { Chart } from 'chart.js';
import 'chartjs-plugin-doughnutlabel';
import { snackbarService } from '@one/web-components';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { NotificationAccountsTableComponent } from '../notification-accounts-table/notification-accounts-table.component';
import { NotificationSearchComponent } from '../notification-search/notification-search.component';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FilterOverlayDialogComponent } from '../filter-overlay-dialog/filter-overlay-dialog.component';
import { AddNoteComponent } from './add-note/add-note.component';
import { NotificationSearchService } from '../notification-search/notification-search.service';
import { DueDateReminderComponent } from '../../create-notification/due-date-reminder/due-date-reminder.component';
import { SnackbarService } from '../../services/snackbar.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DueDateReminderPopupComponent } from '../due-date-reminder-popup/due-date-reminder-popup.component';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { DeleteAttachmentJustificationComponent } from './delete-attachment-justification/delete-attachment-justification.component';
import { AttachmentModificationComponent } from './attachment-modification/attachment-modification.component';
import { NotificationDetailsService } from './notification-details.service';

@Component({
  selector: 'dl-notification-details',
  standalone: true,
  imports: [
    OneWebComponentsAngularModule,
    AddNoteComponent,
    CommonModule,
    FilterOverlayDialogComponent,
    NotificationSearchComponent,
    FormsModule,
    NotificationAccountsTableComponent,
    DueDateReminderPopupComponent,
    DeleteAttachmentJustificationComponent,
    AttachmentModificationComponent,
  ],
  templateUrl: './notification-details.component.html',
  styleUrl: './notification-details.component.scss',
})
export class NotificationDetailsComponent {
  setCompleteButtonVisible: boolean = false;
  isLoading: boolean = false;
  visibleAddNote: boolean = false;
  cancelNotificationDialogVisible: boolean = false;
  cancellationReason: string = '';

  //  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild('exporter', { static: true }) public exporter: ElementRef;

  @ViewChild('donutCustomer1') public donutCustomer1!: ElementRef;
  @ViewChild('donutCustomer2') public donutCustomer2!: ElementRef;
  @ViewChild('statusMenu') statusMenu: any;
  @ViewChild('settingsIcon') settingsIcon: ElementRef;

  // @Output()
  dataToBeDelete: any;
  totalDataToBeDelete: any;

  public labels1 = ['Delivered ($count)', 'Delivery failures ($count)'];
  public labels2 = ['Submitted ($count)', 'Pending ($count)'];

  public colors1 = ['#00875a', '#c03'];
  public colors2 = ['#0066cc', '#606060'];

  public fontColor = '#333';

  public chartData1 = [0, 0];
  public chartData2 = [0, 0];

  public customerChartData1 = [0, 0];
  public customerChartData2 = [0, 0];

  public breadcrumbs: OneBreadcrumb[];

  public donutCustomerChart1: Chart;
  public donutCustomerChart2: Chart;

  public contactDataObj: any = [];
  public notificationDataObj: any;
  public notificationStatusIcon: {};
  public selection = [];
  public selectedRow: any;
  public dataSource = [];
  public displayedColumns = ['select', 'allColumns'];
  public tableData: any[] = [];
  public selectedColumns: any;
  public StatusData: any;
  public notificationId: string;
  // public featureRelease1 = qnsbnurlAPI.isRelease1;
  public notificationData: any;
  public filterOverlayData: any;
  public userPermission: any;

  public uniqueDDCount: number = 0;
  public uniqueDFCount: number = 0;

  public uniqueFSCount: number = 0;
  public uniqueFPCount: number = 0;

  public notificationLabel: any = '';
  public isSetCom: boolean = false;
  public isSetCancelled:boolean = false;
  public accountDataSource = [];
  public accountTableData: any[] = [];
  public accountSelectedColumns: any;
  public accountDataObj: any = [];
  public accountSelection = [];
  public showAccountsTable: boolean = true;
  public AccountSelectedRow: any;
  @ViewChild('accountExporter', { static: true }) accountExporter: ElementRef;
  public feedbackEnabled: boolean = true;
  public calculateStatusCountsForDelivery;
  public calculateStatusCountsForFeedback;
  public notificationReminders: any[] = [];
  private isFetchingReminderDetails = false;
  menuVisible: boolean = false;
  dropdownPosition: { top: string; right: string } = {
    top: '0px',
    right: '0px',
  };
  data: any;
  visibleFilterDialog: boolean;
  dueDateReminderDialogVisible: boolean = false;
  dueDateReminderDialogData: any;
  visibleisDeletionConfirmation: boolean = false;
  visibleisDeletionConfirmationDialogVariable: boolean = false;
  deleteIconDisable: any;
  deletionData: any;
  removedData = 0;
  allData: any;
  attachmentDeleted: any;
  receivedJustification: any;
  isAdding: boolean = false;
  singleAttachmentsName: string = '';

  public constructor(
    public filterOverlay: FilterOverlayDialogService,
    public appUtil: AppUtils,
    public notificationSearchService: NotificationSearchService,
    private _cdr: ChangeDetectorRef,
    private qnsbnservice: QnSbnService,
    private snackBarNotification: SnackbarService,
    private router: Router,
    private _QnSbnDataService: QnSbnDataServiceService,
    private location: Location,
    public notificationDetailsService: NotificationDetailsService,
    public _QnSbnService: QnSbnService,
  ) {
    this.notificationDataObj = history.state;

    if (this.notificationDataObj) {
      this.notificationData = this.notificationDataObj?.notificationData;
      this.notificationId = this.notificationData?.NotificationId;
      this.feedbackEnabled =
        this.notificationData?.FeedbackEnabled ?? this.feedbackEnabled;
      this.contactDataObj = this.notificationDataObj?.contactData;
      this.accountDataObj = this.notificationDataObj?.accountDataObj || [];
    }
  }

  public onSearchValue(value: string): void {
    this.notificationSearchService.getSearchedData(value);
  }

  public ngOnInit(): void {
    this.notificationLabel = this.notificationData.LocalId;
    this.userPermission = this.qnsbnservice.getUserData();
    this.notificationStatusIcon = statusIcon[this.notificationData.Status];
    this.deleteIconDisable = this.notificationData.Status;
    this.breadcrumbs = [
      {
        label: 'Notifications',
        url: '/notification',
      },
      {
        label: this.notificationData.LocalId,
      },
    ];
    // this.accountDataSource.sort = this.sort;
    this.accountTableData = accountTableColumns;
    this.accountDataSource = this.accountTableData;

    // Always use accountTableColumns order for selected columns
    // This ensures columns maintain their original position regardless of session storage
    this.accountSelectedColumns = [
      { key: 'ID', value: 'AccountId' },
      { key: 'Name', value: 'AccountName' },
      { key: 'Date Sent', value: 'AccountDateSent' },
      { key: 'Date Delivered', value: 'AccountDateDelivered' },
      { key: 'Date Read', value: 'AccountDateRead' },
      { key: 'Feedback Received', value: 'AccountFeedbackReceived' },
      { key: 'Status', value: 'AccountStatus' },
      { key: 'Delivery Failures', value: 'AccountDeliveryFailures' },
    ];

    this.calculateStatusCountsForDelivery = function (contacts) {
      let statusCounts1: { [key: string]: number } = {
        Delivered: 0,
        'Delivery failures': 0,
      };

      let customerStatus: { [key: string]: string } = {};

      contacts.forEach(contact => {
        const customerId = contact.AccountId;
        const contactStatus1 = contact.AccountDateDelivered;
        const contactStatus2 = contact.AccountStatus;

        if (!customerStatus[customerId]) {
          if (
            contactStatus2 === 'Delivery Failed' &&
            customerStatus[customerId] !== 'Feedback Received'
          ) {
            customerStatus[customerId] = 'Delivery failures';
          } else if (
            (contactStatus1 !== '' && contactStatus2 !== 'Delivery Failed') ||
            contactStatus2 == 'Delivered'
          ) {
            customerStatus[customerId] = 'Delivered';
          }
        } else {
          if (
            contactStatus2 === 'Delivery Failed' &&
            customerStatus[customerId] !== 'Feedback Received'
          ) {
            customerStatus[customerId] = 'Delivery failures';
          } else if (
            (contactStatus1 !== '' && contactStatus2 !== 'Delivery Failed') ||
            contactStatus2 == 'Delivered'
          ) {
            customerStatus[customerId] = 'Delivered';
          }
        }
      });
      Object.values(customerStatus).forEach(status => {
        statusCounts1[status]++;
      });
      return statusCounts1;
    };

    this.calculateStatusCountsForFeedback = function (contacts) {
      let statusCounts2: { [key: string]: number } = {
        Submitted: 0,
        Pending: 0,
      };

      let customerStatus: { [key: string]: string } = {};

      contacts.forEach(contact => {
        const customerId = contact.AccountId;
        const contactStatus = contact.AccountFeedbackReceived;

        if (!customerStatus[customerId]) {
          if (contactStatus == '') {
            customerStatus[customerId] = 'Pending';
          } else {
            customerStatus[customerId] = 'Submitted';
          }
        } else {
          if (contactStatus == '') {
            customerStatus[customerId] = 'Pending';
          } else {
            customerStatus[customerId] = 'Submitted';
          }
        }
      });
      Object.values(customerStatus).forEach(status => {
        statusCounts2[status]++;
      });
      return statusCounts2;
    };

    this.allData = [
      ...(this.notificationData.NotificationDocuments || []),
      ...(this.notificationData.NotificationAttachments || []),
    ];
    this.removedData = this.allData.filter(item => 'Status' in item).length;

    this.notificationDetailsService.openJustificationDialog$.subscribe(val => {
      this.visibleisDeletionConfirmationDialogVariable = val;
    });

    this.notificationDetailsService.diableFullScreen$.subscribe(val => {
      this.isAdding = val;
    });

    this._cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.notificationDetailsService.diableFullScreen$.subscribe(val => {
      this.isAdding = val;
    });
    this._cdr.detectChanges();
  }

  public openStatusDialog(): void {
    sessionStorage.setItem('reloadOverview', 'true');
    if (this.statusMenu) {
      this.statusMenu.visible = false;
    }
    setTimeout(() => {
      this.setCompleteButtonVisible = true;
      this._cdr.detectChanges();
    }, 150);
  }

  public closeDeleteModal(): void {
    this.setCompleteButtonVisible = false;
  }

  public confirmDelete(): void {
    this.StatusData = {
      NotificationId: this.notificationId,
      Status: 'Completed',
    };

    this.qnsbnservice.setNotificationStatus(this.StatusData).subscribe(
      (response: HttpResponse<any>) => {
        this.notificationData.Status = 'Completed';
        this.isSetCom = true;
        this.notificationStatusIcon = statusIcon[this.notificationData.Status];
        this.snackBarMessage('positive', 'Set Notification Status Complete');

        this.setCompleteButtonVisible = false;
        this._cdr.detectChanges();
      },
      (error: HttpErrorResponse) => {
        this.isSetCom = false;
        this.qnsbnservice.httpErrorHandler(
          error,
          'Set Notification Status Failed.',
        );
        this.setCompleteButtonVisible = false;
      },
    );
  }

  public areAllAccountsFeedbackOverdue(): boolean {
    if (
      !this.accountDataObj ||
      !Array.isArray(this.accountDataObj) ||
      this.accountDataObj.length === 0
    ) {
      return false;
    }
    return this.accountDataObj.every(
      account => account.AccountStatus?.toLowerCase() === 'feedback overdue',
    );
  }

  public ngAfterViewInit(): void {
    this.accountDataSource.forEach(row => {
      const hasSelect = this.accountSelectedColumns.some(
        (item: any) => item.key === row.key,
      );
      if (!row.disabled && hasSelect && !this.isSelectedAccount(row)) {
        this.accountSelection.push(row);
      }
    });

    const accounts = Array.isArray(this.accountDataObj)
      ? this.accountDataObj
      : [];
    const statusCounts1 = this.calculateStatusCountsForDelivery(accounts);
    const statusCounts2 = this.calculateStatusCountsForFeedback(accounts);

    this.uniqueDDCount = statusCounts1['Delivered'];
    this.uniqueDFCount = statusCounts1['Delivery failures'];

    this.uniqueFSCount = statusCounts2['Submitted'];
    this.uniqueFPCount = statusCounts2['Pending'];

    this.customerChartData1 =
      this.uniqueDDCount != 0 || this.uniqueDFCount != 0
        ? [this.uniqueDDCount, this.uniqueDFCount]
        : [0, 0, accounts.length];

    this.customerChartData2 = [this.uniqueFSCount, this.uniqueFPCount];

    this.donutCustomerChart1 = new Chart(this.donutCustomer1.nativeElement, {
      type: 'doughnut',
      data: {
        labels: this.labels1,
        datasets: [
          {
            label: 'Donut Dataset',
            borderWidth: 0,
            backgroundColor: this.colors1,
            data: this.customerChartData1,
            borderColor: '#E557B3',
          },
        ],
      },
      options: {
        cutoutPercentage: 70,
        rotation: 120,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            padding: 20,
            boxWidth: 10,
            fontColor: this.fontColor,
            fontSize: 12,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: context => {
              const index = context.index;
              return `${this.labels1[index].replace('$count', this.customerChartData1[index].toString())}`;
            },
          },
        },
        plugins: {
          doughnutlabel: {
            labels: [
              {
                text: chart => {
                  if (
                    chart.data.datasets[0].data.reduce((a, b) => a + b) == 0
                  ) {
                    return this.accountDataObj?.length || 0;
                  }
                  return chart.data.datasets[0].data.reduce((a, b) => a + b);
                },
                font: {
                  size: '26',
                },
              },
            ],
          },
        },
      },
      plugins: {
        beforeDraw(chart) {
          const legends = chart.legend?.legendItems;
          if (!legends) return;
          legends.forEach((legend, i) => {
            legend.fillStyle = chart.config.data.datasets[0].backgroundColor[i];
            legend.strokeStyle =
              chart.config.data.datasets[0].backgroundColor[i];
            legend.lineWidth = 0;
            const value = chart.config.data.datasets[0].data[i];
            legend.text = legend.text.replace('$count', value);
          });
        },
      },
    });

    if (!this.donutCustomer2?.nativeElement) return;

    this.donutCustomerChart2 = new Chart(this.donutCustomer2.nativeElement, {
      type: 'doughnut',
      data: {
        labels: this.labels2,
        datasets: [
          {
            label: 'Donut Dataset',
            borderWidth: 0,
            backgroundColor: this.colors2,
            data: this.customerChartData2,
            borderColor: '#E557B3',
          },
        ],
      },
      options: {
        cutoutPercentage: 70,
        rotation: 120,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            padding: 20,
            boxWidth: 10,
            fontColor: this.fontColor,
            fontSize: 12,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: context => {
              const index = context.index;
              return `${this.labels2[index].replace('$count', this.customerChartData2[index].toString())}`;
            },
          },
        },
        plugins: {
          doughnutlabel: {
            labels: [
              {
                text: chart => {
                  return chart.data.datasets[0].data.reduce((a, b) => a + b);
                },
                font: {
                  size: '26',
                },
              },
            ],
          },
        },
      },
      plugins: {
        beforeDraw(chart) {
          const legends = chart.legend?.legendItems;
          if (!legends) return;
          legends.forEach((legend, i) => {
            legend.fillStyle = chart.config.data.datasets[0].backgroundColor[i];
            legend.strokeStyle =
              chart.config.data.datasets[0].backgroundColor[i];
            legend.lineWidth = 0;
            const value = chart.config.data.datasets[0].data[i];
            legend.text = legend.text.replace('$count', value);
          });
        },
      },
    });

    this.notificationDetailsService.diableFullScreen$.subscribe(val => {
      this.isAdding = val;
    });
  }

  public downloadDocument(globalNotificationId: string, fileExtension: string) {
    this.qnsbnservice.downloadPiosDocumentApi(
      globalNotificationId,
      fileExtension,
    );
  }

  public downloadAttachment(fileName: string, notificationId: string) {
    this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId);
  }

  public filterData() {
    this.filterOverlay.filterData$.subscribe(filterValue => {
      this.filterOverlayData = filterValue;
    });
    this.data = this.filterOverlayData;
    this.visibleFilterDialog = true;
    this._cdr.detectChanges();
  }

  public onFilterDialogClosed() {
    this.visibleFilterDialog = false;
  }

  public isAllSelectedAccount(): boolean {
    const numSelected = this.accountSelection.length;
    const numDisabled = this.accountDataSource.filter(
      row => row.disabled,
    ).length;
    const numRows = this.accountDataSource.length;
    return numSelected + numDisabled === numRows;
  }

  // check if any row is selected
  public hasValueAccount(): boolean {
    return this.accountSelection.length > 0;
  }

  // master toggle (select all / deselect all)
  public masterToggleAccount(): void {
    if (this.isAllSelectedAccount()) {
      this.accountSelection = [];
    } else {
      this.accountSelection = this.accountDataSource.filter(
        row => !row.disabled,
      );
    }
  }

  // check if a row is selected
  public isSelectedAccount(row: any): boolean {
    return this.accountSelection.some(selected => selected.key === row.key);
  }

  // toggle single row selection
  public toggleSelectionAccount(row: any): void {
    if (!row.disabled) {
      const index = this.accountSelection.findIndex(
        selected => selected.key === row.key,
      );
      if (index === -1) {
        this.accountSelection.push(row);
      } else {
        this.accountSelection.splice(index, 1);
      }
    }
  }

  public getAccountSelectedColumns() {
    // Maintain original order from accountTableColumns constant
    const orderedSelection = accountTableColumns.filter(col =>
      this.accountSelection.some(selected => selected.key === col.key),
    );

    // Force complete re-render by hiding and showing the table
    this.showAccountsTable = false;
    this._cdr.detectChanges();

    setTimeout(() => {
      this.accountSelectedColumns =
        orderedSelection.length > 0
          ? [...orderedSelection.map(col => ({ ...col }))]
          : [...accountTableInit.map(col => ({ ...col }))];

      sessionStorage.setItem(
        'AccountSelectedColumns',
        JSON.stringify(this.accountSelectedColumns),
      );
      this.showAccountsTable = true;
      this._cdr.detectChanges();
    }, 0);

    this.closeMenu();
  }

  snackBarMessage(status: any, message: string) {
    snackbarService.show({
      message: message,
      snackbarProps: {
        status: status,
        direction: 'horizontal',
        showClose: true,
        elevated: false,
        duration: 5000,
        verticalPlacement: 'top',
        horizontalPlacement: 'right',
      },
    });
  }

  toggleMenu(): void {
    if (!this.menuVisible) {
      this.updateDropdownPosition();
    }
    this.menuVisible = !this.menuVisible;
    this._cdr.detectChanges();
  }

  private updateDropdownPosition(): void {
    if (this.settingsIcon && this.settingsIcon.nativeElement) {
      const el = this.settingsIcon.nativeElement;
      const rect = el.getBoundingClientRect();
      this.dropdownPosition = {
        top: `${rect.bottom + 8}px`,
        right: `${window.innerWidth - rect.right}px`,
      };
    } else {
      // Fallback position
      this.dropdownPosition = {
        top: '200px',
        right: '50px',
      };
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (this.menuVisible) {
      this.updateDropdownPosition();
    }
  }

  closeMenu(): void {
    this.menuVisible = false;
    this._cdr.detectChanges();
  }

  public addNoteForm(): void {
    this.data = { tableData: this.notificationDataObj };
    this.visibleAddNote = true;
    this._cdr.detectChanges();
  }

  public cancelNotification(): void {
    sessionStorage.setItem('reloadOverview', 'true');
    if (this.statusMenu) {
      this.statusMenu.visible = false;
    }
    this.cancellationReason = '';
    setTimeout(() => {
      this.cancelNotificationDialogVisible = true;
      this._cdr.detectChanges();
    }, 150);
  }

  public closeCancelNotificationModal(): void {
    this.cancelNotificationDialogVisible = false;
    this.cancellationReason = '';
    this._cdr.detectChanges();
  }

  public confirmCancelNotification(): void {
    if (!this.cancellationReason || !this.cancellationReason.trim()) {
      return;
    }

    this.qnsbnservice.cancelNotification(this.notificationId, this.cancellationReason.trim()).subscribe(
      (response: any) => {
        const data = typeof response === 'string' ? JSON.parse(response) : (response?.body ?? response);
        this.notificationData.Status = 'Cancelled';
        this.notificationData.CancellationDate = data?.cancellationDate;
        this.notificationData.CancelledBy = data?.cancelledBy;
        this.notificationData.CancellationReason = data?.cancelReason ?? this.cancellationReason.trim();
        this.isSetCancelled = true;
        this.notificationStatusIcon = statusIcon[this.notificationData.Status] || statusIcon['Completed'];
        this.snackBarMessage('positive', 'Notification has been cancelled successfully.');
        this.cancelNotificationDialogVisible = false;
        this.cancellationReason = '';
        this._cdr.detectChanges();
      },
      (error: HttpErrorResponse) => {
        this.isSetCancelled = false;
        this.qnsbnservice.httpErrorHandler(error, 'Cancel Notification Failed.');
        this.cancelNotificationDialogVisible = false;
      }
    );
  }

  public onNoteAdded(note: any): void {
    this.visibleAddNote = false;
    this.notificationData.NoteDate = new Date();
    this._cdr.detectChanges();
  }

  public openDueDateRemindersDialog(): void {
    // To prevent multiple simultaneous API requests
    if (this.isFetchingReminderDetails) {
      return;
    }

    if (!this.notificationId) {
      this.snackBarNotification.snackBarMessage(
        'alarm',
        'Notification details are unavailable',
      );
      return;
    }

    if (this.statusMenu) {
      this.statusMenu.visible = false;
    }

    this.isFetchingReminderDetails = true;

    // To fetch reminder details from the API
    this.qnsbnservice.viewReminderLocal(this.notificationId).subscribe(
      response => {
        if (response) {
          this.notificationData = response[0];
        }
        this.isFetchingReminderDetails = false;
        this.openDueDateReminderModal();
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(
          error,
          'Could not fetch reminder details.',
        );
        this.isFetchingReminderDetails = false;
      },
    );
  }

  public deleteAttachment(event, docs, attachments) {
    event.preventDefault(); // stop default behavior
    event.stopPropagation();
    this.dataToBeDelete = [docs || [], attachments || [], this.notificationData];
    this.visibleisDeletionConfirmation = true;
  }
  
  onDeletionConfrimation(event): void {
    if (event.length == 0) {
      this.visibleisDeletionConfirmationDialogVariable = false;
      this.notificationDetailsService.setOpenJustificationDialogToggle(false);
      this.receivedJustification = event;
    } else {
      this.visibleisDeletionConfirmationDialogVariable = false;
      this.notificationDetailsService.setOpenJustificationDialogToggle(false);
      this.visibleisDeletionConfirmation = false;
      this.receivedJustification = event;

      if (this.attachmentDeleted.length > 0) {
        this.totalDataToBeDelete = [
          ...this.attachmentDeleted[0],
          ...this.attachmentDeleted[1],
        ];
        let attachmentForDeletion;

        if (this.attachmentDeleted[2] > 1) {
          let attachmentsName = [];
          this.attachmentDeleted[3].map(file => {
            if (file?.FileName) {
              attachmentsName.push(file.FileName);
            } else if (file?.Title) {
              attachmentsName.push(file.Title);
            }
          });
          attachmentForDeletion = {
            action: 'REMOVE_ATTACHMENT',
            notificationId: this.notificationData.NotificationId,
            attachmentFilename: attachmentsName,
            justificationText: this.receivedJustification,
            userId: this.notificationData.UserId,
            userRole: this.notificationData.UserRole,
          };
        } else {
          let attachmentsName = '';
          if (this.attachmentDeleted[3][0]?.FileName) {
            attachmentsName = this.attachmentDeleted[3][0].FileName;
            this.singleAttachmentsName = this.attachmentDeleted[3][0].FileName;
          } else if (this.attachmentDeleted[3][0]?.Title) {
            attachmentsName = this.attachmentDeleted[3][0].Title;
            this.singleAttachmentsName = this.attachmentDeleted[3][0].Title;
          }
          attachmentForDeletion = {
            action: 'REMOVE_ATTACHMENT',
            notificationId: this.notificationData.NotificationId,
            attachmentFilename: attachmentsName,
            justificationText: this.receivedJustification,
            userId: this.notificationData.UserId,
            userRole: this.notificationData.UserRole,
          };
        }

        this._QnSbnService
          .removeAttachmentsFromNotification(attachmentForDeletion)
          .subscribe(
            res => {

              if (this.attachmentDeleted[2] > 1) {
                const skippedAttachments =
                  res?.body?.results?.skipped ?? res?.body?.details?.skipped;
                const successedAttachments =
                  res?.body?.results?.successful ??
                  res?.body?.details?.successful;
                const failedAttachments =
                  res?.body?.results?.failed ?? res?.body?.details?.failed;

                if (skippedAttachments?.length > 0) {
                  const fileNames = skippedAttachments
                    .map(data => `"${data.filename}"`)
                    .join(', ');
                  const word =
                    skippedAttachments.length > 1
                      ? 'attachments are'
                      : 'attachment is';
                  let adjective;
                  if (
                    this.attachmentDeleted?.[3]?.length ==
                    skippedAttachments.length &&
                    skippedAttachments.length > 1
                  ) {
                    adjective = 'All';
                  } else {
                    adjective = fileNames;
                  }
                  const existing = JSON.parse(localStorage.getItem('snackbarQueue') || '[]');
                  existing.push({
                    type: 'alarm', 
                    message: `${adjective} ${word} skipped while removing from the notification`
                  });
                  localStorage.setItem('snackbarQueue', JSON.stringify(existing));
                }
                if (successedAttachments?.length > 0) {
                  const fileNames = successedAttachments
                    .map(item =>
                      typeof item === 'string'
                        ? `"${item}"`
                        : `"${item?.filename}"`,
                    )
                    .join(', ');
                  const word =
                    successedAttachments.length > 1
                      ? 'attachments are'
                      : 'attachment is';
                  let adjective;
                  if (
                    this.attachmentDeleted?.[3]?.length ==
                    successedAttachments.length &&
                    successedAttachments.length > 1
                  ) {
                    adjective =
                      this.totalDataToBeDelete?.length ==
                      this.attachmentDeleted?.[3]?.length
                        ? 'All'
                        : 'All selected';
                  } else {
                    adjective = fileNames;
                  }

                  const existing = JSON.parse(localStorage.getItem('snackbarQueue') || '[]');
                  existing.push({
                    type: 'positive',
                    message: `${adjective} ${word} removed successfully from the notification`
                  });
                  localStorage.setItem('snackbarQueue', JSON.stringify(existing));
                }
                if (failedAttachments?.length > 0) {
                  const fileNames = failedAttachments
                    .map(item =>
                      typeof item === 'string'
                        ? `"${item}"`
                        : `"${item?.filename}"`,
                    )
                    .join(', ');
                  const word =
                    failedAttachments.length > 1
                      ? 'attachments are'
                      : 'attachment is';
                  let adjective;
                  if (
                    this.attachmentDeleted?.[3]?.length ==
                    failedAttachments.length &&
                    failedAttachments.length > 1
                  ) {
                    adjective =
                      this.totalDataToBeDelete?.length ==
                      this.attachmentDeleted?.[3]?.length
                        ? 'All'
                        : 'All selected';
                  } else {
                    adjective = fileNames;
                  }

                  const existing = JSON.parse(localStorage.getItem('snackbarQueue') || '[]');
                  existing.push({
                    type: 'alarm', 
                    message: `${adjective} ${word} failed while removing from the notification`
                  });
                  localStorage.setItem('snackbarQueue', JSON.stringify(existing));
                }
                sessionStorage.setItem('reloadOverview', 'true');
                this.router.navigate(['/notification']);
              } else {
                const singleAttachmentDeletion = res?.statusCode;
                
                if (singleAttachmentDeletion == 200) {
                  const existing = JSON.parse(localStorage.getItem('snackbarQueue') || '[]');
                  existing.push({
                    type: 'positive',
                    message: `${res?.body?.attachmentFilename} attachment is removed successfully from the notification`
                  });
                  localStorage.setItem('snackbarQueue', JSON.stringify(existing));
                } else {
                  const existing = JSON.parse(localStorage.getItem('snackbarQueue') || '[]');
                  existing.push({
                    type: 'alarm', 
                    message: `${this.singleAttachmentsName} attachment is failed while removing from the notification`
                  });
                  localStorage.setItem('snackbarQueue', JSON.stringify(existing));
                }
                sessionStorage.setItem('reloadOverview', 'true');
                this.router.navigate(['/notification']);
              }
            },
            (error: HttpErrorResponse) => {
              const fileNames = this.attachmentDeleted?.[3]?.length
                ? this.attachmentDeleted[3]
                  .map(d => d?.FileName || d?.Title)
                  .filter(Boolean)
                  .map(name => `"${name}"`)
                  .join(', ')
                : `"unknown"`;
              const word =
                this.attachmentDeleted[2] > 1
                  ? 'attachments are'
                  : 'attachment is';
              let adjective;
              if (
                this.totalDataToBeDelete.length == this.attachmentDeleted[2] &&
                this.attachmentDeleted[2] > 1
              ) {
                adjective = 'All';
              } else {
                adjective = fileNames;
              }
              this._QnSbnService.httpErrorHandler(
                error,
                adjective +
                ' ' +
                word +
                ' removing from the notification failed.',
              );
            },
          );
        this.notificationDetailsService.selectedIds.clear();
        this.notificationDetailsService.selectedDeletingItems = [];
      }
    }
    this._cdr.detectChanges();
  }

  onDeletion(event) {
    if (event.length > 0) {
      this.attachmentDeleted = event;
      this.notificationDetailsService.selectedDeletingItems =
        this.attachmentDeleted?.[3];
      this.notificationDetailsService.selectedIds = this.attachmentDeleted?.[2];
    } else {
      this.attachmentDeleted = event;
      this.visibleisDeletionConfirmation = false;
      this.notificationDetailsService.selectedIds.clear();
    }
  }

  onUploadFiles(event) {
    this.visibleisDeletionConfirmation = false;

    if (event?.addedFiles?.length > 0 && event?.response?.statusCode === 200) {
      const newAttachments = event.addedFiles.map(file => ({
        FileName: file.name,
        FileSize: file.size,
        NotificationDoc: false,
        Status: 'Active',
      }));
      this.notificationData.NotificationAttachments = [
        ...(this.notificationData.NotificationAttachments || []),
        ...newAttachments,
      ];
      this.dataToBeDelete = [
        this.notificationData.NotificationAttachments || [],
        this.notificationData.NotificationDocuments || [],
        this.notificationData,
      ];
      this._cdr.detectChanges();
    }
  }

  private openDueDateReminderModal(): void {
    // Map existing reminders from notification data to the format expected by the popup
    const existingReminders = Array.isArray(
      this.notificationData?.NotificationReminders,
    )
      ? this.notificationData.NotificationReminders.map(element => ({
        reminderId: element.ReminderId,
        reminderDate: element.ReminderDueDate,
        reminderSubject: element.ReminderSubject,
        reminderMessage: element.ReminderMessage,
        reminderSendMode: element.ReminderSendAutomatically ? '0' : '1',
        reminderSendAutomatically: element.ReminderSendAutomatically,
        reminderSendStatus: element.ReminderSendStatus || 'Not Sent',
        reminderAddTemplate: element.ReminderAddTemplate || '',
        reminderActionIcons: true,
      }))
      : [];

    // Prepare the reminder data (same structure as Angular Material version)
    this.dueDateReminderDialogData = {
      notificationData: this.notificationData,
      notificationId: this.notificationId,
      feedbackDueDate: this.notificationData?.FeedbackDueDate,
      dueDateEnabled: this.notificationData?.DueDateEnabled,
      feedbackEnabled: this.feedbackEnabled,
      reminders: existingReminders,
      accounts: this.contactDataObj,
    };

    // Show the modal using OneWebComponents pattern
    this.dueDateReminderDialogVisible = true;
    this._cdr.detectChanges();
  }

  public onDueDateReminderDialogClose(result: any): void {
    // Close the modal
    this.dueDateReminderDialogVisible = false;

    // Process the result (same logic as Angular Material afterClosed)
    if (result) {
      if (typeof result.dueDateEnabled === 'boolean') {
        this.notificationData.DueDateEnabled = result.dueDateEnabled;
      }
      if (result.feedbackDueDate !== undefined) {
        this.notificationData.FeedbackDueDate = result.feedbackDueDate;
      }
      this._cdr.detectChanges();
    }
  }

  public openNotificationDetails(row) {
    sessionStorage.setItem('reloadOverview', 'true');

    if (
      this.userPermission.CreateNotification ||
      this.userPermission.SendNotification
    ) {
      this.qnsbnservice.createNotificationVersion(row.NotificationId).subscribe(
        (response: any) => {
          const versionData = response.body || response;

          this._QnSbnDataService.resetAll();

          this.qnsbnservice
            .getNotificationContactDetails(row.NotificationId)
            .subscribe(
              (newdata: any) => {
                if (newdata.length > 0) {
                  const recipientData = [];
                  newdata.forEach(element => {
                    recipientData.push({
                      customerId: element.CustomerId,
                      customerName: element.CustomerName,
                      customerContactName: element.CustomerContactName,
                      customerEmail: element.CustomerContactEmail,
                      sourceName: element.DataSource,
                    });
                  });
                  const sourceName = [
                    ...new Set(newdata.map(x => x.DataSource)),
                  ];

                  let sourceEle = [];
                  sourceName.forEach(source => {
                    sourceEle.push({ label: source, value: source });
                  });
                  this._QnSbnDataService.getMappedQnsbnData(
                    {
                      recipientTable: recipientData,
                      sourceName: sourceEle,
                    },
                    'Recipient',
                  );
                }
              },
              (error: HttpErrorResponse) => {
                this.qnsbnservice.httpErrorHandler(
                  error,
                  'Could not fetch contact details.',
                );
              },
            );

          const notificationData = versionData.NotificationId
            ? versionData
            : row;

          this.qnsbnservice.setLocalNotificationID(
            notificationData.LocalId || row.LocalId,
          );
          this._QnSbnDataService.getMappedQnsbnData(
            notificationData,
            'DraftNotification',
          );
          this._QnSbnDataService.getMappedQnsbnData(
            {
              NotificationId:
                notificationData.NotificationId || row.NotificationId,
              Type: notificationData.Type || row.Type,
              Title: notificationData.Title || row.Title,
              GlobalId: notificationData.GlobalId || row.GlobalId,
              Country: notificationData.Country || row.Country,
              GlobalNotificationId:
                notificationData.GlobalNotificationId ||
                row.GlobalNotificationId,
              CreationDate: notificationData.CreationDate || row.CreationDate,
              LocalId: notificationData.LocalId || row.LocalId,
              Status: notificationData.Status || row.Status,
              UserId: notificationData.UserId || row.UserId,
              UserRole: notificationData.UserRole || row.UserRole,
              LocalNotificationLanguage:
                notificationData.LocalNotificationLanguage ||
                row.LocalNotificationLanguage,
            },
            'LocalNotificationId',
          );

          if (
            notificationData.NotificationDocuments &&
            notificationData.NotificationDocuments.length > 0
          ) {
            this._QnSbnDataService.getMappedQnsbnData(
              notificationData.NotificationDocuments[0],
              'NotificationDoc',
            );
          }
          if (notificationData.CustomerFeedbackItems) {
            const feedbackData = [];
            notificationData.CustomerFeedbackItems.forEach(element => {
              feedbackData.push({
                dragHandle: '',
                selectType: element.FeedbackItemType,
                selectText: element.FeedbackItemLabel,
                selectMandatory: element.FeedbackItemMandatory || 'Mandatory',
                iconSets: 'more-icon',
                dropDownOpt: element.FeedbackItemDropdown || [],
                radioOpt: element.FeedbackItemRadio || [],
              });
            });
            this._QnSbnDataService.getMappedQnsbnData(
              feedbackData,
              'ConfigureFeedBack',
            );
          }
          if (notificationData.MessageTitle || notificationData.MessageBody)
            this._QnSbnDataService.getMappedQnsbnData(
              {
                subjectName: notificationData.MessageTitle,
                messageAttachmentRTEText: notificationData.MessageBody,
                templateId: notificationData.TemplateId || '',
              },
              'MessageAttachment',
            );
          if (notificationData.NotificationAttachments) {
            const fileList = [];
            let fileSize = 0;
            notificationData.NotificationAttachments.forEach(element => {
              const filetype = element.FileName.split('.').pop();
              fileSize = fileSize + element.FileSize;
              if (element.NotificationDoc) {
                this._QnSbnDataService.getMappedQnsbnData(
                  [
                    {
                      name: element.FileName,
                      size: element.FileSize,
                      type: filetype,
                      fileIcon: this.appUtil.formatFilesIcons(filetype),
                    },
                  ],
                  'NotificationDocFileList',
                );
              } else {
                fileList.push(<any>{
                  name: element.FileName,
                  size: element.FileSize,
                  type: filetype,
                  fileIcon: this.appUtil.formatFilesIcons(filetype),
                });
              }
            });
            this._QnSbnDataService.getMappedQnsbnData(
              {
                fileList: fileList,
                totalAllFileSize: fileSize,
                fileSizeobject: {},
              },
              'MessageAttachmentFileList',
            );
          }
          if (notificationData.FeedbackDueDate)
            this._QnSbnDataService.getMappedQnsbnData(
              {
                feedbackDueDate: notificationData.FeedbackDueDate,
              },
              'FeedbackDueDate',
            );
          const notificationReminders = Array.isArray(
            notificationData.NotificationReminders,
          )
            ? notificationData.NotificationReminders
            : [];
          if (notificationReminders.length > 0) {
            const reminderData = notificationReminders.map(element => ({
              reminderId: element.ReminderId,
              reminderDate: element.ReminderDueDate,
              reminderSubject: element.ReminderSubject,
              reminderMessage: element.ReminderMessage,
              reminderSendMode: element.ReminderSendAutomatically ? '0' : '1',
              reminderSendAutomatically: element.ReminderSendAutomatically,
              reminderSendStatus: element.ReminderSendStatus || 'Not Sent',
              reminderAddTemplate: element.ReminderAddTemplate || '',
              reminderActionIcons: true,
            }));
            this._QnSbnDataService.getMappedQnsbnData(
              {
                remindersData: reminderData,
              },
              'NotificationReminders',
            );
          } else {
            this._QnSbnDataService.getMappedQnsbnData(
              {
                remindersData: [],
              },
              'NotificationReminders',
            );
          }
          const dueDateToggle =
            notificationData.DueDateEnabled ?? notificationData.dueDateEnabled;
          if (typeof dueDateToggle === 'boolean') {
            this._QnSbnDataService.setDDToggle(dueDateToggle);
          }
          const feedbackToggle =
            notificationData.FeedbackEnabled ??
            notificationData.feedbackEnabled;
          if (typeof feedbackToggle === 'boolean') {
            this._QnSbnDataService.setFBToggle(feedbackToggle);
          }
          this.router.navigateByUrl('/create-notification', {
            state: { notificationData: notificationData },
          });
        },
        (error: HttpErrorResponse) => {
          this.qnsbnservice.httpErrorHandler(
            error,
            'Failed to create notification version.',
          );
        },
      );
    } else {
      this.snackBarMessage(
        'alarm',
        'You do not have permission to create a new version',
      );
    }
  }

  public viewSupersedingNotification(row): void {
    const notificationId = row.SupersededByNotificationId;
    this.qnsbnservice
      .getNotificationOverviewData(
        ['all'] as any,
        ['all'] as any,
        ['all'] as any,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.qnsbnservice.httpErrorHandler(
            error,
            'Could not fetch notification data.',
          );
          return of({ notificationOverview: [] });
        }),
      )
      .subscribe((response: any) => {
        const notifications = response.notificationOverview || [];
        const supersedingNotification = notifications.find(
          n => n.NotificationId === notificationId,
        );

        if (!supersedingNotification) {
          this.snackBarNotification.snackBarMessage(
            'alarm',
            'Superseding notification not found',
          );

          return;
        }
        if (supersedingNotification.Status === 'Draft') {
          this.openNotificationDetails(supersedingNotification);
          return;
        }

        const notificationReminders = Array.isArray(
          supersedingNotification.NotificationReminders,
        )
          ? supersedingNotification.NotificationReminders
          : [];

        const contacts$ = this.qnsbnservice
          .getNotificationContactDetails(notificationId)
          .pipe(
            catchError((error: HttpErrorResponse) => {
              this.qnsbnservice.httpErrorHandler(
                error,
                'Could not fetch contact details.',
              );
              return of([]);
            }),
          );
        const accounts$ = this.qnsbnservice.getAccountList(notificationId).pipe(
          catchError((error: HttpErrorResponse) => {
            this.qnsbnservice.httpErrorHandler(
              error,
              'Could not fetch Account Data',
            );
            return of([]);
          }),
        );

        forkJoin({ contacts: contacts$, accounts: accounts$ }).subscribe(
          result => {
            const contactDataWithReminders = Array.isArray(result.contacts)
              ? result.contacts.map(contact => ({
                ...contact,
                CustomerReminderDetails:
                  contact.CustomerReminderDetails &&
                    contact.CustomerReminderDetails.length > 0
                    ? contact.CustomerReminderDetails
                    : notificationReminders.map(reminder => ({
                      ReminderId: reminder.ReminderId,
                      ReminderDueDate: reminder.ReminderDueDate || '',
                      ReminderSubject: reminder.ReminderSubject || '',
                      ReminderMessage: reminder.ReminderMessage || '',
                      ReminderSendStatus:
                        reminder.ReminderSendStatus || 'Not Sent',
                      ReminderSendAutomatically:
                        reminder.ReminderSendAutomatically,
                    })),
              }))
              : result.contacts;

            const accountDataObj =
              result.accounts && result.accounts.body
                ? result.accounts.body
                : result.accounts;
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['/notification-details'], {
                  state: {
                    notificationData: supersedingNotification,
                    contactData: contactDataWithReminders,
                    accountDataObj,
                    notificationReminders,
                  },
                });
              });
          },
        );
      });
  }

  navigateTo(event: Event, url: string): void {
    // Prevent any default browser behavior that might cause page reload
    event.preventDefault();
    event.stopPropagation();

    // Ensure we don't reload data when navigating back - use cached data
    sessionStorage.setItem('reloadOverview', 'false');
    // Navigate directly to notification page
    this.router.navigate(['notification']);
  }

  public isAllAttachmentsRemoved(docs, atts): boolean {
    if (
      (!docs ||
        !docs?.length ||
        !docs[0]?.PIMID ||
        docs?.every(doc => doc?.Status === 'Removed')) &&
      (!atts || !atts?.length || atts?.every(att => att?.Status === 'Removed'))
    ) {
      return true;
    }
    return false;
  }
}
